import { c as _c } from "react/compiler-runtime";
import { CoordinatesXIcon, CoordinatesYIcon, CoordinatesZIcon } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { MarkupMeasurement } from "@pages/project-details/project-markups/sidepanel/markup-measurement";
import { MarkupSidePanelSection } from "@pages/project-details/project-markups/sidepanel/markup-sidepanel-section";
import { convertDistance } from "@utils/unit-utils";
import { getCoordinateZUp } from "@utils/vector-utils";
/**
 * Coordinates of an annotation, in the coordinate system the Sphere Viewer shows them in, each
 * copied with a click like the measurement values. Coordinates are always in meters, unlike the
 * measurement values that follow the unit of the user settings
 */
export function MarkupPosition(t0) {
  const $ = _c(19);
  const {
    markup
  } = t0;
  if (!markup.globalPose) {
    return null;
  }
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== markup.globalPose.pos) {
    const {
      x,
      y,
      z
    } = getCoordinateZUp(markup.globalPose.pos);
    const coordinates = [{
      tooltip: "X",
      value: x,
      icon: <CoordinatesXIcon />
    }, {
      tooltip: "Y",
      value: y,
      icon: <CoordinatesYIcon />
    }, {
      tooltip: "Z",
      value: z,
      icon: <CoordinatesZIcon />
    }];
    T1 = MarkupSidePanelSection;
    t3 = "Position";
    t4 = "position";
    t5 = "markup-side-panel-position";
    T0 = Stack;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        gap: 1
      };
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    t2 = coordinates.map(_temp);
    $[0] = markup.globalPose.pos;
    $[1] = T0;
    $[2] = T1;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    T0 = $[1];
    T1 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[9] !== T0 || $[10] !== t1 || $[11] !== t2) {
    t6 = <T0 sx={t1}>{t2}</T0>;
    $[9] = T0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== T1 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <T1 title={t3} trackingName={t4} dataTestId={t5}>{t6}</T1>;
    $[13] = T1;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function _temp(t0) {
  const {
    tooltip,
    value,
    icon
  } = t0;
  return <MarkupMeasurement key={tooltip} value={convertDistance(value, "meters")} tooltip={tooltip} icon={icon} copiedTitle="Coordinate copied" trackingSection="position" />;
}